import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { Tenant } from '../../api/types';
import { TenantConfig } from '../../tenants/config';

interface UserAuthenticatedPayload {
    permissions: string[];
}

interface TenantSelectedPayload {
    tenant: Tenant;
}

export interface AuthenticationState {
    tenant: Tenant | null;
    config: TenantConfig | null;
    permissions: string[];
}

const initialState: AuthenticationState = {
    tenant: null,
    config: null,
    permissions: [],
};

const authenticationSlice = createSlice({
    name: 'authentication',
    initialState,
    reducers: {
        userAuthenticated: (
            state,
            action: PayloadAction<UserAuthenticatedPayload>,
        ) => {
            state.permissions = action.payload.permissions;
        },
        tenantSelected: (
            state,
            action: PayloadAction<TenantSelectedPayload>,
        ) => {
            state.tenant = action.payload.tenant;
            localStorage.setItem('selectedTenant', action.payload.tenant);
        },
        setConfig: (state, action: PayloadAction<TenantConfig>) => {
            state.config = action.payload;
        },
    },
});

export const { userAuthenticated, tenantSelected, setConfig } =
    authenticationSlice.actions;

export { authenticationSlice };
